
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $ff91563bc46bbab4$exports = {};
$parcel$extendImportMap({
    "120r0": "senda-hero.3491fc4d.avif",
    "1Cj1z": "senda-hero.6521b704.webp",
    "OIuOC": "senda-hero.da2a3d6b.jpeg",
    "c7GkR": "parc-central-hero.1d8051ae.avif",
    "cWMmf": "parc-central-hero.38c21b10.webp",
    "82hJp": "parc-central-hero.f48c5d87.jpeg",
    "eX79r": "xana-hero.a7980dd6.avif",
    "j1ENd": "xana-hero.01e22d0e.webp",
    "8tV6C": "xana-hero.c083fd0f.jpeg"
});

// LOGO ANIMATION
var $17bda991c267b7ce$var$_document_querySelector;
const $17bda991c267b7ce$var$stage = document.getElementById('stage');
const $17bda991c267b7ce$var$hasSeenIntro = sessionStorage.getItem('introSeen');
if ($17bda991c267b7ce$var$stage) {
    if ($17bda991c267b7ce$var$hasSeenIntro) {
        // The user has already seen the animation in this session —> skip it
        $17bda991c267b7ce$var$stage.remove();
        document.body.classList.remove('is-loading');
    } else {
        // First time or refresh —> show the animation
        sessionStorage.setItem('introSeen', 'true');
        $17bda991c267b7ce$var$stage.addEventListener('animationend', (e)=>{
            if (e.animationName === 'hideIntro') {
                $17bda991c267b7ce$var$stage.remove();
                document.body.classList.remove('is-loading');
            }
        });
    }
    // This IIFE calculates the necessary scale for the fill element to cover the entire stage during the animation. 
    // It also updates this calculation on window resize to ensure the animation remains consistent across different screen sizes.
    (function() {
        const fill = document.getElementById('fill');
        if (!fill) return; // If the stage has already been removed, do nothing.
        // Calculates the scale-end for the fill based on the stage size and the fill's actual size in px (respecting rem units).
        function calcFillScale() {
            const maxDim = Math.max($17bda991c267b7ce$var$stage.offsetWidth, $17bda991c267b7ce$var$stage.offsetHeight);
            const fillSize = fill.offsetWidth; // Reads the actual size in px, respecting rem units.
            fill.style.setProperty('--scale-end', Math.ceil(maxDim * 1.5 / fillSize));
        }
        calcFillScale();
        window.addEventListener('resize', calcFillScale);
    })();
}
// Page enter animation — only if the user has already seen the intro
if ($17bda991c267b7ce$var$hasSeenIntro) ($17bda991c267b7ce$var$_document_querySelector = document.querySelector('.page')) === null || $17bda991c267b7ce$var$_document_querySelector === void 0 ? void 0 : $17bda991c267b7ce$var$_document_querySelector.classList.add('page-enter');
// CURSOR PREVIEW
// 1. Selección de elementos
const $17bda991c267b7ce$var$items = document.querySelectorAll(".archive-list-item");
const $17bda991c267b7ce$var$preview = document.querySelector(".cursor-preview");
const $17bda991c267b7ce$var$previewPicture = $17bda991c267b7ce$var$preview === null || $17bda991c267b7ce$var$preview === void 0 ? void 0 : $17bda991c267b7ce$var$preview.querySelector("picture");
var $57aec304f1d3f7b4$exports = {};
$57aec304f1d3f7b4$exports = $parcel$resolve("120r0");


var $b7802e6e99888c0a$exports = {};
$b7802e6e99888c0a$exports = $parcel$resolve("1Cj1z");


var $8e84cdc26d8c0044$exports = {};
$8e84cdc26d8c0044$exports = $parcel$resolve("OIuOC");


var $4d42eba27164eec4$exports = {};
$4d42eba27164eec4$exports = $parcel$resolve("c7GkR");


var $5f7bd6dd7a9cb821$exports = {};
$5f7bd6dd7a9cb821$exports = $parcel$resolve("cWMmf");


var $8135097cce27a8fa$exports = {};
$8135097cce27a8fa$exports = $parcel$resolve("82hJp");


var $ab849b475b73591b$exports = {};
$ab849b475b73591b$exports = $parcel$resolve("eX79r");


var $5f0698c48b340069$exports = {};
$5f0698c48b340069$exports = $parcel$resolve("j1ENd");


var $8582f298bb2720bc$exports = {};
$8582f298bb2720bc$exports = $parcel$resolve("8tV6C");


// 2. Definición de imágenes
const $17bda991c267b7ce$var$images = {
    senda: {
        avif: new URL($57aec304f1d3f7b4$exports).href,
        webp: new URL($b7802e6e99888c0a$exports).href,
        jpg: new URL($8e84cdc26d8c0044$exports).href
    },
    parc: {
        avif: new URL($4d42eba27164eec4$exports).href,
        webp: new URL($5f7bd6dd7a9cb821$exports).href,
        jpg: new URL($8135097cce27a8fa$exports).href
    },
    xana: {
        avif: new URL($ab849b475b73591b$exports).href,
        webp: new URL($5f0698c48b340069$exports).href,
        jpg: new URL($8582f298bb2720bc$exports).href
    }
};
// 3. Función para actualizar el picture completo
function $17bda991c267b7ce$var$updatePicture(imgSet) {
    if (!$17bda991c267b7ce$var$previewPicture) return;
    // Reconstruye el contenido del <picture> completo
    $17bda991c267b7ce$var$previewPicture.innerHTML = `
        <source srcset="${imgSet.avif}" type="image/avif">
        <source srcset="${imgSet.webp}" type="image/webp">
        <img src="${imgSet.jpg}" alt="">
    `;
}
// 4. Precarga
Object.values($17bda991c267b7ce$var$images).forEach((imgSet)=>{
    // Precarga jpg como fallback fiable
    const img = new Image();
    img.src = imgSet.jpg;
});
// 5. Eventos
if ($17bda991c267b7ce$var$preview && $17bda991c267b7ce$var$previewPicture) $17bda991c267b7ce$var$items.forEach((item)=>{
    item.addEventListener("mouseenter", ()=>{
        const key = item.dataset.image;
        const imgSet = $17bda991c267b7ce$var$images[key];
        if (!imgSet) return;
        $17bda991c267b7ce$var$updatePicture(imgSet);
        $17bda991c267b7ce$var$preview.style.opacity = "1";
        $17bda991c267b7ce$var$preview.style.transform = "scale(1)";
    });
    item.addEventListener("mouseleave", ()=>{
        $17bda991c267b7ce$var$preview.style.opacity = "0";
        $17bda991c267b7ce$var$preview.style.transform = "scale(0.8)";
    });
    item.addEventListener("mousemove", (e)=>{
        const offset = 20;
        $17bda991c267b7ce$var$preview.style.left = e.clientX + offset + "px";
        $17bda991c267b7ce$var$preview.style.top = e.clientY + offset + "px";
    });
});
// console.log("Preview ready");
// PAGE ANIMATION
// import { gsap } from "gsap";
// window.addEventListener("load", () => {
//   gsap.fromTo(".page",
//     { y: "10%", opacity: 0 },
//     { y: "0%", opacity: 1, duration: 0.8, ease: "power2.out" }
//   );
// });
// DETAILS TOGGLE
document.querySelectorAll("details").forEach((detail)=>{
    const summary = detail.querySelector("summary");
    detail.addEventListener("toggle", ()=>{
        summary.textContent = detail.open ? "Read less" : "Read more";
    });
});


//# sourceMappingURL=repo.8a0bc1d7.js.map
